/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Report API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponsePredefinedReportExportExcelResponse,
  ApiResponsePredefinedReportResponse,
  GetV1PreDefinedReportsExportExcelListParams,
  PostV1PreDefinedReportsExportExcelTemplate200,
  PredefinedReportExportExcelRequest,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary 사전 정의 리포트 추출 필터 목록
 */
export const getV1PreDefinedReportsExportExcel = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<ApiResponsePredefinedReportResponse>(
    { url: `/api/v1/pre-defined/reports/export/excel`, method: 'GET', signal },
    options,
  );
};

export const getGetV1PreDefinedReportsExportExcelQueryKey = () => {
  return ['api', 'v1', 'pre-defined', 'reports', 'export', 'excel'] as const;
};

export const getGetV1PreDefinedReportsExportExcelQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcel>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcel>>, TError, TData>
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV1PreDefinedReportsExportExcelQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcel>>> = ({
    signal,
  }) => getV1PreDefinedReportsExportExcel(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcel>>,
    TError,
    TData
  >;
};

export type GetV1PreDefinedReportsExportExcelQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcel>>
>;
export type GetV1PreDefinedReportsExportExcelQueryError = ErrorType<unknown>;

/**
 * @summary 사전 정의 리포트 추출 필터 목록
 */

export function useGetV1PreDefinedReportsExportExcel<
  TData = Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcel>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcel>>, TError, TData>
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1PreDefinedReportsExportExcelQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 사전 정의 리포트 추출 목록
 */
export const getV1PreDefinedReportsExportExcelList = (
  params?: MaybeRef<GetV1PreDefinedReportsExportExcelListParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customAxiosInstance<ApiResponsePredefinedReportExportExcelResponse>(
    {
      url: `/api/v1/pre-defined/reports/export/excel/list`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetV1PreDefinedReportsExportExcelListQueryKey = (
  params?: MaybeRef<GetV1PreDefinedReportsExportExcelListParams>,
) => {
  return [
    'api',
    'v1',
    'pre-defined',
    'reports',
    'export',
    'excel',
    'list',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetV1PreDefinedReportsExportExcelListQueryOptions = <
  TData = Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcelList>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV1PreDefinedReportsExportExcelListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcelList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV1PreDefinedReportsExportExcelListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcelList>>
  > = ({ signal }) => getV1PreDefinedReportsExportExcelList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcelList>>,
    TError,
    TData
  >;
};

export type GetV1PreDefinedReportsExportExcelListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcelList>>
>;
export type GetV1PreDefinedReportsExportExcelListQueryError = ErrorType<unknown>;

/**
 * @summary 사전 정의 리포트 추출 목록
 */

export function useGetV1PreDefinedReportsExportExcelList<
  TData = Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcelList>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<GetV1PreDefinedReportsExportExcelListParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getV1PreDefinedReportsExportExcelList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV1PreDefinedReportsExportExcelListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 데이터 블록 엑셀 틀 다운로드
 */
export const postV1PreDefinedReportsExportExcelTemplate = (
  predefinedReportExportExcelRequest: MaybeRef<PredefinedReportExportExcelRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  predefinedReportExportExcelRequest = unref(predefinedReportExportExcelRequest);

  return customAxiosInstance<PostV1PreDefinedReportsExportExcelTemplate200>(
    {
      url: `/api/v1/pre-defined/reports/export/excel/template`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: predefinedReportExportExcelRequest,
      signal,
    },
    options,
  );
};

export const getPostV1PreDefinedReportsExportExcelTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV1PreDefinedReportsExportExcelTemplate>>,
    TError,
    { data: BodyType<PredefinedReportExportExcelRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV1PreDefinedReportsExportExcelTemplate>>,
  TError,
  { data: BodyType<PredefinedReportExportExcelRequest> },
  TContext
> => {
  const mutationKey = ['postV1PreDefinedReportsExportExcelTemplate'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV1PreDefinedReportsExportExcelTemplate>>,
    { data: BodyType<PredefinedReportExportExcelRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV1PreDefinedReportsExportExcelTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV1PreDefinedReportsExportExcelTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV1PreDefinedReportsExportExcelTemplate>>
>;
export type PostV1PreDefinedReportsExportExcelTemplateMutationBody =
  BodyType<PredefinedReportExportExcelRequest>;
export type PostV1PreDefinedReportsExportExcelTemplateMutationError = ErrorType<unknown>;

/**
 * @summary 데이터 블록 엑셀 틀 다운로드
 */
export const usePostV1PreDefinedReportsExportExcelTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV1PreDefinedReportsExportExcelTemplate>>,
      TError,
      { data: BodyType<PredefinedReportExportExcelRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV1PreDefinedReportsExportExcelTemplate>>,
  TError,
  { data: BodyType<PredefinedReportExportExcelRequest> },
  TContext
> => {
  const mutationOptions = getPostV1PreDefinedReportsExportExcelTemplateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
